import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit'
import { isRejected, isRejectedWithValue } from '@reduxjs/toolkit'
import { captureException } from '../vendor/sentry';
import { snackActions } from './slices/snackSlice/snack';

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (isRejectedWithValue(action) || isRejected(action)) {
      captureException(action.error, { source: 'rtkQueryErrorLogger', action });
      console.warn('We got a rejected action!', action);
      api.dispatch(snackActions.pushError({
        name: action.error.name || 'Error',
        message: action.error.message || 'An error occurred',
        severity: 'error',
        error: action.error as Error,
      }));
    }

    return next(action)
  }
